module.exports = __webpack_public_path__ + "static/showreel-3dd5f8ac79857eb508a63e06068c6361.mp4";